import localeConfig from '~/config/locale-config'
import type { Locales } from '~/types/Locale'

export const COUNTRY = ['Australia', 'Canada', 'New Zealand']
export const COUNTRY_CODE = ['AU', 'CA', 'NZ']
export type Country = (typeof COUNTRY)[number]
export type CountryCode = (typeof COUNTRY_CODE)[number]

export const mapCountryCodeToCountry = (countryCode: CountryCode): Country => {
  switch (countryCode) {
    case 'AU':
      return COUNTRY[0]
    case 'CA':
      return COUNTRY[1]
    case 'NZ':
      return COUNTRY[2]
    default:
      return undefined
  }
}

export const displayLanguageSelector = (locale: string, localeCodes: string[]) => {
  return (locale === 'en-CA' || locale === 'fr') && localeCodes.includes('en-CA') && localeCodes.includes('fr')
}

// SFCC only accepts an explicit `locale` for French; every other locale must omit the
// parameter rather than send an empty string. Spread the result into `parameters`.
export const sfccLocaleParams = (locale?: Locales): { locale?: string } =>
  locale === 'fr' ? { locale: localeConfig[locale].code } : {}
